module.exports = __webpack_public_path__ + "img/success-img.58d286a2.png";